import { type ReactNode, useId } from "react";

import { VisuallyHidden } from "@chakra-ui/react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { getClientEnv } from "@shared/libs/runtime-env";

type Props<T> = {
  children: ReactNode;
  language: T;
};

export const CaptchaProvider = <T extends string>({
  children,
  language,
}: Props<T>) => {
  const GOOGLE_RECAPTCHA_KEY = getClientEnv("VITE_GOOGLE_RECAPTCHA_KEY");
  const id = useId();
  if (!GOOGLE_RECAPTCHA_KEY) {
    throw new Error("You must specify a GOOGLE_RECAPTCHA_KEY");
  }
  return (
    <GoogleReCaptchaProvider
      container={{
        element: id,
        parameters: {},
      }}
      language={language}
      reCaptchaKey={GOOGLE_RECAPTCHA_KEY}
    >
      {children}
      <VisuallyHidden id={id} />
    </GoogleReCaptchaProvider>
  );
};
